import { useContext } from "react";

// context
import { IOSInputIsFocusedContext } from "./index";

export const useIosInputFocusLightBox = () => {
    const props = useContext(IOSInputIsFocusedContext);
    const { setIsOpen, isIOS } = props;

    const onFocus = () => {
        if (isIOS) {
            setIsOpen(true);
        }
    };
    const onBlur = () => {
        if (isIOS) {
            setIsOpen(false);
        }
    };

    return {
        ...props,
        setIsOpen,
        onFocus,
        onBlur
    };
};
